import { FaHeartPulse } from 'react-icons/fa6'
import {
  FaSyringe,
  FaMicroscope,
  FaFileMedical,
  FaCog,
  FaTimesCircle,
  FaFileUpload,
  FaFolderOpen,
  FaChartBar
} from 'react-icons/fa'
import { MdAddTask, MdCheckCircle, MdPendingActions, MdHistory, MdMonitorHeart } from 'react-icons/md'

export const sidebarLinks = t => {
  return [
    {
      id: 1,
      label: t('Dashboard'),
      icon: <FaHeartPulse className='text-[15px]' />,
      link: '/dashboard',
      serviceIds: [1, 2],
      modules: ['dashboard']
    },
    {
      id: 2,
      label: t('Order Management'),
      icon: <MdPendingActions className='text-[15px]' />,
      link: '/order-management',
      serviceIds: [1, 2],
      modules: ['order', 'cancel', 'history']
    },
    // {
    //   id: 5,
    //   label: t('Sample'),
    //   icon: <FaClipboardCheck className='text-[15px]' />,
    //   link: '/receiving',
    //   serviceIds: [1],
    //   modules: ['sample', 'result']
    // },
    {
      id: 8,
      label: t('Add External Result'),
      icon: <FaFileUpload className='text-[15px]' />,
      link: '/add-external-result',
      serviceIds: [1],
      modules: ['external_result']
    },
    {
      id: 9,
      label: t('Reports'),
      icon: <FaFileMedical className='text-[15px]' />,
      link: '/reports',
      serviceIds: [1],
      modules: ['report']
    },
    {
      id: 11,
      label: t('Statistics Reports'),
      icon: <FaChartBar className='text-[15px]' />,
      link: '/lab/statistics',
      serviceIds: [1],
      modules: ['lab_statistics']
    },
    {
      id: 10,
      label: t('Manual Result Documents'),
      icon: <FaFolderOpen className='text-[15px]' />,
      link: '/lab/manual-result-documents',
      serviceIds: [1],
      modules: ['result']
    },
    {
      id: 14,
      label: t('Settings'),
      icon: <FaCog className='text-[15px]' />,
      link: '/lab/settings',
      serviceIds: [1],
      modules: [
        'external_lab',
        'lab_test',
        'lab_test_component',
        'user',
        'profile',
        'specimen',
        'role',
        'payer',
        'pricelist'
      ]
    },
    {
      id: 15,
      label: t('Add Result'),
      icon: <MdAddTask className='text-[15px]' />,
      link: '/add-radiology-result',
      serviceIds: [2],
      modules: ['result']
    },
    {
      id: 25,
      label: t('Add External Result'),
      icon: <FaFileUpload className='text-[15px]' />,
      link: '/add-external-radiology-result',
      serviceIds: [2],
      modules: ['external_result']
    },
    {
      id: 16,
      label: t('Approved Results'),
      icon: <MdCheckCircle className='text-[15px]' />,
      link: '/approved-results',
      serviceIds: [2],
      modules: ['result']
    },
    {
      id: 26,
      label: t('Radiology Reports'),
      icon: <FaChartBar className='text-[15px]' />,
      link: '/radiology/statistics',
      serviceIds: [2],
      modules: ['lab_statistics', 'report', 'result', 'order', 'history', 'test']
    },
    {
      id: 18,
      label: t('Manual Result Documents'),
      icon: <FaFolderOpen className='text-[15px]' />,
      link: '/radiology/manual-result-documents',
      serviceIds: [2],
      modules: ['result']
    },
    {
      id: 17,
      label: t('Settings'),
      icon: <FaCog className='text-[15px]' />,
      link: '/radiology/settings',
      serviceIds: [2],
      modules: ['role', 'user', 'test_component', 'test', 'pricelist']
    },
    {
      id: 21,
      label: t('Visit Status Logs'),
      icon: <MdHistory className='text-[15px]' />,
      link: '/visit-status-logs',
      serviceIds: [1],
      modules: ['visit_status']
    },
    // {
    //   id: 27,
    //   label: t('Queue Monitor'),
    //   icon: <MdMonitorHeart className='text-[15px]' />,
    //   link: '/queue-monitor',
    //   serviceIds: [1, 2],
    //   modules: ['dashboard']
    // }
  ]
}
